// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentSurveyQuestionModel {
    static getAttributeTypeMap() {
        return EnrollmentSurveyQuestionModel.attributeTypeMap;
    }
}
EnrollmentSurveyQuestionModel.discriminator = undefined;
EnrollmentSurveyQuestionModel.additionalProperties = false;
EnrollmentSurveyQuestionModel.attributeTypeMap = [
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerKey",
        "baseName": "answerKey",
        "type": "number"
    },
    {
        "name": "answerText",
        "baseName": "answerText",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentSurveyQuestionModel.js.map